import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';

@Component({
  selector: 'app-wo-travel-tab',
  templateUrl: './wo-travel-tab.component.html',
  standalone: false,
})
export class WoTravelTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;
  @Input() travelUnitType: string = 'miles';

  rows: any[] = [];
  isLoaded = false;
  unitTypes = ['miles', 'km'];

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getWorkOrder(this.headerId).subscribe({
      next: (res: any) => {
        this.rows = (res?.wo_travel ?? []).map((r: any) => ({...r}));
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  addRow(): void {
    this.rows.push({
      id: null,
      header_id: this.headerId,
      user_id: null,
      date: new Date().toISOString().substring(0, 10),
      distance: 0,
      unit_type: this.travelUnitType || 'miles',
      description: '',
      rate_per_unit: null,
      billable: true,
      billed_amount: null,
      invoice_detail_id: null,
      sort_order: (this.rows.length + 1) * 10,
    });
  }

  removeRow(index: number): void {
    const row = this.rows[index];
    if (row.invoice_detail_id) {
      this.notification.showWarningToast('This line has been invoiced and cannot be deleted.');
      return;
    }
    this.confirmDialog.confirmThis(
      ['Delete this travel entry?'],
      () => {
        this.rows.splice(index, 1);
      },
      () => {
      }
    );
  }

  save(): void {
    if (!this.headerId) {
      return;
    }
    const body = {wo_header: {}, wo_travel: this.rows};
    console.log('[WO Travel Save] PATCH api/WorkOrder/' + this.headerId, body);
    this.woService.updateWorkOrder(this.headerId, body).subscribe({
      next: () => {
        this.notification.showSuccessToast('Travel saved.');
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving travel.');
      }
    });
  }

  computedBilled(row: any): number | null {
    if (!row.billable || !row.rate_per_unit) {
      return null;
    }
    return Math.round((row.distance || 0) * row.rate_per_unit * 100) / 100;
  }
}
